// extracted by mini-css-extract-plugin
export default {"btn":"CallMenu_btn__JgrOn","callBtnContent":"CallMenu_callBtnContent__-5rnU","dropdownBox":"CallMenu_dropdownBox__li33m"};